import React from 'react';
import PropTypes from 'prop-types';
import TextInputField from 'material-ui/TextField';
import { TableRowColumn } from 'material-ui/Table';

const DateTableCell = (props) => {
    const { value, onChangeInput, name, style } = props;

    return (
        <TableRowColumn style={ style }>
            <TextInputField
                value={ value[name] }
                name={ name }
                onChange={ (e) => {
                    return onChangeInput(e, value);
                } }
                type='date'
            />

        </TableRowColumn>
    );
};

DateTableCell.propTypes = {
    value: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    onChangeInput: PropTypes.func.isRequired,
    style: PropTypes.object,
};

export default DateTableCell;


// WEBPACK FOOTER //
// ./src/pages/products/configuration/DateTableCell.js